import { simpleFormatter, getLabelFormatterThatDisplaysOnly } from './labelFormatter';

function calculateMaxLabelsNumber(referenceWidth, maxLabelsInReferenceWidth, width) {
  const maxLabels = (width * maxLabelsInReferenceWidth) / referenceWidth;
  return maxLabels;
}

function calculateMaxLabelsInNumberHeight(height) {
  const referenceHeight = 300;
  const maxLabelsInReferenceHeight = 15;
  const maxLabels = calculateMaxLabelsNumber(referenceHeight, maxLabelsInReferenceHeight, height);
  return maxLabels;
}

function calculateMaxLabelsInNumberWidth(width) {
  const referenceWidth = 387;
  const maxLabelsInReferenceWidth = 12;
  return calculateMaxLabelsNumber(referenceWidth, maxLabelsInReferenceWidth, width);
}

/**
 * retorna o formatador de labels do gráfico de barras baseado no número de barras {barsNumber},
 * no tamanho do gráfico {chartSize} e numa flag indicando se o gráfico de barras
 * é vertical ou horizontal. {isBarsVertical}
 * @param {*} barsNumber numero de barras do grafico
 * @param {*} chartSize tamanho do gráfico {width: number; height: number}
 * @param {*} isBarsVertical flag indicando se as barras do gráfico são verticais ou horizontais
 * @parma {*} visibleBarIndex a barra que deve ser exibida caso apenas a label de uma barra possa ser visivel.
 * Isto ocorre quando as labels não cabem no espaço da barra. Então uma barra é elencada para exibir a label.
 */
export function getLabelFormatBySeriesNumber(barsNumber, chartSize, isBarsVertical = true, visibleBarIndex, withPercent = true) {
  let maxLabelsNumber;
  if (isBarsVertical) {
    maxLabelsNumber = calculateMaxLabelsInNumberWidth(chartSize.width);
  } else {
    maxLabelsNumber = calculateMaxLabelsInNumberHeight(chartSize.height);
  }

  if (barsNumber > maxLabelsNumber) {
    return getLabelFormatterThatDisplaysOnly(visibleBarIndex, withPercent);
  }
  return (params) => simpleFormatter(params, withPercent);
}

export function updateOptionWithLabelFormatter(option, labelFormatter) {
  const newSeries = option.series.map((serie) => ({
    ...serie,
    label: {
      ...serie.label,
      formatter: labelFormatter,
    },
  }));

  return {
    ...option,
    series: newSeries,
  };
}
